import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import { FaArrowDown } from "react-icons/fa";
import { ReactComponent as DownloadIcon } from "../../assets/icons/generic/downloadGeneric.svg";

const DownloadButton = ({ downloadCSV }) => {
  return (
    <DownloadButtonContainer onClick={downloadCSV}>
      <DownloadIcon />
      <span>Export</span>
    </DownloadButtonContainer>
  );
};

export default DownloadButton;

const DownloadButtonContainer = styled.button`
  display: flex;
  align-items: center;
  gap: 0px;
  padding: 4px 8px;

  svg {
    height: 12px;
  }

  border-radius: 4px;
  background: ${lightThemeColors.secondaryBackground};
  color: ${lightThemeColors.secondaryAccent};
  border: none;
  border: 1px solid ${lightThemeColors.menuBorder};

  span {
    font-size: 12px;
    font-weight: 500;
  }
`;
